export interface PlotSection {
  id: string;
  title: string;
  icon: string;
  body: string[];
}

export const plotSections: PlotSection[] = [
  {
    id: 'origin',
    title: '缘起：门铃响起的那一刻',
    icon: 'ri-home-heart-line',
    body: [
      '故事从一次再普通不过的放学回家开始。因为家中的突发状况，全校知名的辣妹黑田美咲拎着行李箱，出现在普通男高中生佐藤悠斗的家门口，提出了一个让他措手不及的请求。',
      '没有宿命的邂逅，也没有戏剧化的英雄救美——一切就从一个简单的"暂住"开始，却足以让两个人原本毫无交集的生活轨道彻底撞在一起。',
    ],
  },
  {
    id: 'daily',
    title: '日常：同一屋檐下的磨合',
    icon: 'ri-discuss-line',
    body: [
      '住在同一个屋檐下，意味着完全不同的生活习惯要被强行揉进同一个画面：作息时间、房间整洁度、晚餐的口味、周末的消磨方式……吵吵闹闹，却在一次次斗嘴和互相迁就中慢慢形成默契。',
      '悠斗满墙的漫画收藏意外成了两人共同的暗号。那个平时张扬自信的辣妹，一聊起漫画就眼睛发亮——反差之下，是只有悠斗才能看到的、最真实的她。',
    ],
  },
  {
    id: 'heart',
    title: '心动：从"寄居"到"在意"',
    icon: 'ri-heart-3-line',
    body: [
      '一场大雨、一次文化祭、一顿妹妹张罗的晚餐……很多看似平常的瞬间，悄然改变了两人对彼此的态度。美咲在慌乱中被闺蜜点破心意，悠斗也在一次次的并肩中，意识到"麻烦"与"在意"其实只有一线之隔。',
      '当暑假来临，两人第一次认真谈起"今后"——留与走、现在与未来，那些藏在日常里不敢说破的话，终于迎来了必须面对的时刻。',
    ],
  },
  {
    id: 'future',
    title: '未来：家门永远为你敞开',
    icon: 'ri-door-open-line',
    body: [
      '当"借住"的理由慢慢褪去，两人才真正明白：让彼此留在身边的，从来不是那一场巧合，而是相处中一点点累积起来的真心。',
      '故事在温暖又平凡的日常中暂告一段落——门铃依然会响起，而这一次，迎接她的，是真正属于"家"的回应。至于这段关系会走向哪里，就留给后续章节继续书写。',
    ],
  },
];

export const storyOverview: string[] = [
  '《泡在我家的辣妹》是一部以"辣妹寄居男同学家"为切入点的青春恋爱喜剧漫画。作品以反差感强烈的两位主角为中心，将校园青春、恋爱心动与温馨日常巧妙融合，用轻松明快的节奏讲述了一段从"被迫同住"到"彼此在意"的故事。',
  '故事没有宏大的世界观，也没有沉重的设定，它的魅力恰恰来自生活本身：一起吃饭、一起追更、一起熬夜看新刊，那些再平凡不过的日常片段，正是两人感情一点点生根发芽的土壤。',
  '如果你喜欢内向男主与外向辣妹的化学反应，也偏爱"反差萌"与温馨日常的治愈感，那么这部作品会是很对味的选择。本页整理了作品的故事主线、核心设定与人物关系，看漫画前先花几分钟补课，追更会更从容。',
];